import { render, staticRenderFns } from "./wqrNewsList.vue?vue&type=template&id=659675a5&scoped=true"
import script from "./wqrNewsList.vue?vue&type=script&lang=js"
export * from "./wqrNewsList.vue?vue&type=script&lang=js"
import style0 from "./wqrNewsList.vue?vue&type=style&index=0&id=659675a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659675a5",
  null
  
)

export default component.exports